'use client'

import { createContext } from 'react'

import { ProfileSettingsContextType } from '@marketplace-web/domain/profile-settings-data'

const ProfileSettingsContext = createContext<ProfileSettingsContextType | null>(null)

export default ProfileSettingsContext
